<script>
import TrackResource from '@/resources/track'

export default {
    components: {},
    computed: {
        resources() {
            if (!this.pageData) {
                return []
            }

            return this.pageData.resources
        },
    },
    watch: {},
    data() {
        return {
            loading: true,
            pageData: null,
            searchQuery: '',
            previewingTrack: null,
        }
    },
    methods: {
        async search() {
            this.loading = true
            this.pageData = await TrackResource.list({ resolveRelated: true, query: { search: this.searchQuery } })
            this.loading = false
        },
        async prevPage() {
            this.pageData = await this.pageData.prevPage()
            await Promise.all(this.pageData.resources.map((resource) => resource.resolveRelated()))
            window.scrollTo(0, 0)
        },
        async nextPage() {
            this.pageData = await this.pageData.nextPage()
            await Promise.all(this.pageData.resources.map((resource) => resource.resolveRelated()))
            window.scrollTo(0, 0)
        },
    },
    async mounted() {
        await this.search()
    },
}
</script>

<template>
    <div>
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <router-link class="nav-link" :to="{ name: 'availabilityCars' }">Available Cars</router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link active" :to="{ name: 'availabilityTracks' }">Available Tracks</router-link>
            </li>
        </ul>

        <b-form @submit.prevent="search()" ref="searchForm" class="mt-3">
            <b-input-group size="sm">
                <b-input v-model="searchQuery" placeholder="Keywords"></b-input>
                <template #append>
                    <b-button variant="primary" type="submit">Search</b-button>
                </template>
            </b-input-group>
        </b-form>

        <hr />

        <b-table-simple v-if="!loading" class="nowrap-table" bordered striped responsive>
            <b-thead>
                <b-tr>
                    <b-th>Track Name</b-th>
                    <b-th>Customer Laps</b-th>
                    <b-th>Absolute Lap Record</b-th>
                </b-tr>
            </b-thead>

            <b-tbody v-if="resources.length > 0">
                <b-tr v-for="(track, i) in resources" :key="i">
                    <b-td class="font-weight-bold"><a href="javascript:{};" @click="previewingTrack = track">{{ track.attributes.name }}</a></b-td>
                    <b-td>{{ Number(track.attributes.laps_count).toLocaleString() }}</b-td>
                    <b-td>
                        <span v-if="track.attributes.laps_record_hms != 0">
                            <strong>{{ track.attributes.laps_record_hms }}</strong> by <strong>{{ track.attributes.laps_record_user }}</strong> — {{ track.attributes.laps_record_car }}
                        </span>
                        <span class="text-muted" v-else>None</span>
                    </b-td>
                </b-tr>
            </b-tbody>

            <b-tbody v-else>
                <b-tr>
                    <b-td colspan="4" class="text-center">
                        <p class="py-5">No tracks matched your search query</p>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <div v-else>
            <hr />
            <b-skeleton-table :rows="5" :columns="4" :table-props="{ bordered: true, striped: true }" />
        </div>

        <p class="text-center text-muted" v-if="pageData && pageData.pages > 1">
            <small>
                <b-button variant="link" @click="prevPage()" :disabled="pageData.page == 1"><b-icon icon="caret-left-square" /></b-button>
                <b-button variant="link" @click="nextPage()" :disabled="pageData.page >= pageData.pages" class="ml-3"><b-icon icon="caret-right-square" /></b-button>
            </small>
        </p>

        <!-- Modals -->
        <b-modal v-if="previewingTrack" visible :title="previewingTrack.attributes.name" size="lg" @hide="previewingTrack = null" hide-footer no-fade centered>
            <b-row>
                <b-col md="6" class="mb-3 mb-md-0">
                    <b-img v-if="previewingTrack.attributes.content_preview_url" :src="previewingTrack.attributes.content_preview_url" fluid rounded alt="Track preview" />
                    <div v-else class="sa-empty">No preview available for this track.</div>
                </b-col>
                <b-col>
                    <dl class="row mb-0">
                        <template v-if="previewingTrack.attributes.sim">
                            <dt class="col-5 text-muted">Simulator</dt>
                            <dd class="col-7">{{ previewingTrack.attributes.sim }}</dd>
                        </template>
                        <dt class="col-5 text-muted">Customer Laps</dt>
                        <dd class="col-7">{{ Number(previewingTrack.attributes.laps_count).toLocaleString() }}</dd>
                    </dl>
                    <div class="mt-3">
                        <div class="text-muted small mb-1">Absolute Lap Record</div>
                        <p class="mb-0" v-if="previewingTrack.attributes.laps_record_hms != 0">
                            <strong>{{ previewingTrack.attributes.laps_record_hms }}</strong>
                            by <strong>{{ previewingTrack.attributes.laps_record_user }}</strong>
                            <span class="text-muted">&mdash; {{ previewingTrack.attributes.laps_record_car }}</span>
                        </p>
                        <p class="text-muted mb-0" v-else>No record laps yet.</p>
                    </div>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
.nowrap-table {
    td,
    th {
        white-space: nowrap;
        max-width: 300px;
        overflow: hidden;
    }
}
</style>
